
function converterData(dataString) {
  const partes = dataString.split(/[\/ :]/); // Divide a string em dia, mês, ano, hora, minuto e segundo
  const dia = partes[0];
  const mes = partes[1];
  const ano = partes[2];
  const hora = partes[3];
  const minuto = partes[4];
  const segundo = partes[5];

  return `${ano}-${mes}-${dia} ${hora}:${minuto}:${segundo}`; // Usa template literals para formatar
}

function formatarDataResumida(dataString) {
  const data = new Date(dataString);
  const dia = String(data.getUTCDate()).padStart(2, '0');
  const mes = String(data.getUTCMonth() + 1).padStart(2, '0'); // Janeiro é 0
  const ano = data.getUTCFullYear();

  return `${dia}/${mes}/${ano}`;
}

function formatPlaca(placa) {
  // Remove todos os caracteres não numéricos ou letras
  const placaLimpa = placa.replace(/[^A-Za-z0-9]/g, '');
  // Adiciona a máscara de placa '000-0000' (com 7 caracteres no total)
  if (placaLimpa.length <= 3) {
    return placaLimpa.toUpperCase();
  } else if (placaLimpa.length <= 6) {
    return placaLimpa.substring(0, 3) + '-' + placaLimpa.substring(3, 6).toUpperCase();
  } else {
    return placaLimpa.substring(0, 3) + '-' + placaLimpa.substring(3, 7).toUpperCase();
  }
};

function decodeJWT(token) {
  // Se o token não for válido ou não tiver 3 partes, retorna null
  if (!token || token.split('.').length !== 3) {
    return null;
  }

  const base64Url = token.split('.')[1]; // Obtém a parte "payload" do token
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/'); // Ajusta a codificação para base64 padrão

  // Decodifica a string base64 para JSON
  const jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));

  // Retorna o payload como um objeto JavaScript
  return JSON.parse(jsonPayload);
};


function formatarCelular(value) {
  if (!value) {
    return null
  } else {
    value = value.replace(/\D/g, '') || 0;
  }
  if (value.length > 10) {
    value = value.replace(/^(\d{2})(\d{5})(\d{4}).*/, '($1) $2-$3');
  } else {
    value = value.replace(/^(\d{2})(\d{4})(\d{0,4}).*/, '($1) $2-$3');
  }
  return value;
}

const formatarNumero = (valor) => {
  if (!valor) return "";
  return Number(valor.replace(/\D/g, "")).toLocaleString("pt-BR");
};

const converterMoedaParaNumero = (valor) => {
  if (!valor) return 0;

  // Remove "R$", espaços e pontos, substitui vírgula por ponto
  let numeroLimpo = valor.replace(/R\$\s?|\./g, "").replace(",", ".");

  // Converte para número decimal
  return (numeroLimpo);
};

const formatarMoedaBRL = (valor) => {
  if (!valor) return "";
  let numeroConvertido = Number(valor);
  let numeroLimpo = 0;
  let valorNovo = valor;
  if (Number.isInteger(valor)) {
    numeroConvertido = numeroConvertido.toFixed(2);
    numeroLimpo = String(numeroConvertido).replace(/\D/g, "");
  } else {
    const vlrNovo = String(valor)
    const casasDecimais = vlrNovo.split(".")[1]?.length || 0;
    if (casasDecimais === 1) {
      valorNovo = parseFloat(valor).toFixed(2)
    }
    numeroLimpo = String(valorNovo).replace(/\D/g, "");
  }


  // Converte para número e formata no padrão brasileiro
  let numeroFormatado = (Number(numeroLimpo) / 100).toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });

  return numeroFormatado;
};


const formatarData = (data) => {
  const dataCorrigida = new Date(data);
  dataCorrigida.setMinutes(dataCorrigida.getMinutes() + dataCorrigida.getTimezoneOffset()); // Ajuste de fuso horário
  return dataCorrigida.toLocaleDateString('pt-BR');
};

const normalizarNumero = (valor) => {
  if (typeof valor !== "string") return NaN; // Garante que o valor é uma string

  // Remove qualquer caractere que não seja número, vírgula ou ponto
  valor = valor.replace(/[^\d,.-]/g, '');

  // Se tiver mais de uma vírgula ou ponto, pode ser um caso inválido
  const temMultiplasVirgulas = (valor.match(/,/g) || []).length > 1;
  const temMultiplosPontos = (valor.match(/\./g) || []).length > 1;
  if (temMultiplasVirgulas || temMultiplosPontos) return NaN;

  // Substitui vírgula decimal por ponto para padronizar como número float
  valor = valor.replace(',', '.');

  // Converte para float
  const numero = parseFloat(valor);

  return isNaN(numero) ? NaN : numero;
}

function hasMinNonNumericChars(str) {
  const onlyLetters = str.replace(/[^a-zA-Z]/g, '');
  return onlyLetters.length >= 3;
};

function divideTexto(term) {
  const asteriskIndex = term.indexOf('*');
  const quantidadeExtraida = term.slice(0, asteriskIndex); // Parte antes do asterisco
  const textPart = term.slice(asteriskIndex + 1); // Parte depois do asterisco
  const numberPart = asteriskIndex < 0 ? 1 : Number(quantidadeExtraida);
  const regex = /^(\d+(\.\d*)?)\*(.+)$/;

  const match = term.match(regex);

  return { quantidadeExtraida, textPart, numberPart }
}

function divideTextoNew(term) {
  // regex: opcionalmente começa com f ou a, seguido de número, depois *, depois texto
  const regex = /^([fa]?)(\d+(\.\d+)?)\*(.+)$/i;
  const match = term.match(regex);

  if (!match) {
    // Caso não tenha * ou não siga o padrão, retorna "normal" sem quantidade
    return { tipo: "normal", quantidadeExtraida: 1, textPart: term };
  }

  const prefixo = match[1].toLowerCase(); // f / a / vazio
  const numberPart = Number(match[2]);
  const textPart = match[4].trim();

  let tipo = "normal";
  if (prefixo === "f") tipo = "fracionado";
  if (prefixo === "a") tipo = "atacado";

  return { numberPart, textPart, tipo };
}

function divideTextoSemRegex(term) {
  let tipo = "normal";
  let numberPart = 1;
  let textPart = term;

  // só tenta separar se existir "*"
  const asteriskIndex = term.indexOf("*");
  if (asteriskIndex > 0) {
    let prefixoQuantidade = term.slice(0, asteriskIndex); // antes do *
    textPart = term.slice(asteriskIndex + 1).trim();       // depois do *
    if (textPart.substring(0, 2) === '23') {
      tipo = "fracionado";
    }
    // verifica se começa com letra
    const primeiraLetra = prefixoQuantidade[0];
    if (isNaN(primeiraLetra)) {
      // é um prefixo de tipo (f, a, etc.)
      const prefixo = primeiraLetra.toLowerCase();
      if (prefixo === "f") tipo = "fracionado";
      else if (prefixo === "a") tipo = "atacado";
      else tipo = prefixo; // se no futuro quiser "p"=promo, etc.

      numberPart = Number(prefixoQuantidade.slice(1));
    } else {
      // não tem prefixo, é normal
      numberPart = Number(prefixoQuantidade);
    }
  }

  if (term.substring(0, 2) === "23") {
    tipo = "fracionado";
  }
  return { tipo, numberPart, textPart };
}

function moedaBRL(valor) {
  let formatNumber = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(valor);

  return formatNumber;
}

function calculateTotal(valorVenda, quantidade) {
  let total = (valorVenda * quantidade).toFixed(3); // Retorna 15.86

  total = Math.round(total * 100) / 100;
  return total;

}

function getPrecoUnitario(produto) {
  // Preço promocional tem prioridade
  if (produto.precoPromocao) {
    return Number(produto.precoPromocao.valor_promocao);
  }

  // Preço fracionado
  if (produto.f) { // supondo que f = fracionado
    return Number(produto.f); // ou produto.f3 dependendo da sua estrutura
  }

  // Preço atacado
  if (produto.a) { // supondo que a = atacado
    return Number(produto.a); // ou produto.a1.126
  }

  // Preço normal (primeiro da lista ou vlrVenda)
  if (produto.Precos && produto.Precos.length > 0) {
    return Number(produto.Precos[0].preco_venda);
  }

  return Number(produto.vlrVenda);
}

function getPrecos(produto) {
  // Preço base: fracionado > atacado > lista > vlrVenda
  let precoBase = produto.f ?? produto.a ?? (produto.Precos?.[0]?.preco_venda ? Number(produto.Precos[0].preco_venda) : Number(produto.vlrVenda));

  // Preço unitário: se houver promoção, usa-a
  let precoUnitario = produto.precoPromocao ? Number(produto.precoPromocao.valor_promocao) : precoBase;

  return { precoBase: Number(precoBase), precoUnitario: Number(precoUnitario) };
}

module.exports = {
  converterData, formatarDataResumida, formatarData, formatPlaca, decodeJWT, formatarCelular, converterMoedaParaNumero, formatarNumero, formatarMoedaBRL, normalizarNumero,
  hasMinNonNumericChars, divideTexto, moedaBRL, calculateTotal, divideTextoNew, divideTextoSemRegex, getPrecoUnitario, getPrecos
};